import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import './i18n';
import App from './App';
import { AuthProvider } from './AuthContext';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "",
  environment: process.env.REACT_APP_ENVIRONMENT || "production",
  release: process.env.REACT_APP_SENTRY_RELEASE || "",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
  beforeSend(event) {
    // Don't capture 401 errors — expected for expired/missing tokens
    const message = event.exception?.values?.[0]?.value ?? "";
    if (message.includes("401") || message.includes("Unauthorized")) return null;
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <p style={{ padding: 24, fontFamily: "sans-serif" }}>
          Terjadi kesalahan. Silakan refresh halaman.
        </p>
      }
      showDialog={false}
    >
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
